export default {
  tableData: {
    data: [],
    count: 0
  },
  locationData: null,
};
